module.exports = __webpack_public_path__ + "img/people.65acd556.svg";